<template>
  <div>
    <v-row>
      <v-col>
        <span class="text-subtitle-2">{{ title }}</span>
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <input-email
          label="Email"
          v-model="emailModel"
          :required="isRequired"
        />
      </v-col>
      <v-col v-if="telefoneFixo">
        <input-phone
          label="Telefone Fixo"
          v-model="telefoneFixoModel"
          :required="telefoneFixoIsRequired"
          tel
        />
      </v-col>
      <v-col v-if="telefoneCelular">
        <input-phone
          label="Telefone Celular"
          v-model="telefoneCelularModel"
          :required="isRequired"
          cel
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>

export default {
  props: {
    value: null,
    title: {
      type: String,
      default: 'Dados de Contato'
    },
    isRequired: {
      type: Boolean,
      default: true
    },
    telefoneFixoIsRequired: {
      type: Boolean,
      default: false
    },
    telefoneFixo: {
      type: Boolean,
      default: true
    },
    telefoneCelular: {
      type: Boolean,
      default: true
    },
    tipoContato: {
      type: Number,
    },
  },
  data () {
    return {
      modelNames: {
        type: Object,
        default: () => ({
          email: 'Email',
          telefoneFixo: 'TelefoneFixo1',
          telefoneCelular: 'TelefoneCelular1'
        })
      },
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    emailModel: {
      get () {
        return this.model[this.modelNames.email]
      },
      set (value) {
        this.$set(this.model, this.modelNames.email, value)
      }
    },
    telefoneFixoModel: {
      get () {
        return this.model[this.modelNames.telefoneFixo]
      },
      set (value) {
        this.$set(this.model, this.modelNames.telefoneFixo, value)
      }
    },
    telefoneCelularModel: {
      get () {
        return this.model[this.modelNames.telefoneCelular]
      },
      set (value) {
        this.$set(this.model, this.modelNames.telefoneCelular, value)
      }
    }
  },
  mounted () {
    switch (this.tipoContato) {
      case this.$aux.TipoDadoEnum.Conjuge:
        this.modelNames = {
          email: 'EmailConjuge',
          telefoneFixo: 'TelefoneFixoConjuge',
          telefoneCelular: 'TelefoneCelularConjuge'
        }
        break;
      case this.$aux.TipoDadoEnum.Comercial:
        this.modelNames = {
          email: 'EmailTrabalho',
          telefoneFixo: 'TelefoneFixoTrabalho',
          telefoneCelular: 'TelefoneCelularTrabalho'
        }
        break;
      case this.$aux.TipoDadoEnum.Participante:
        this.modelNames = {
          email: 'Email',
          telefoneFixo: 'TelefoneFixo',
          telefoneCelular: 'TelefoneCelular'
        }
        break;
      default:
        this.modelNames = {
          email: 'Email',
          telefoneFixo: 'TelefoneFixo1',
          telefoneCelular: 'TelefoneCelular1'
        }
    }
  }
}
</script>
